<template>
  <div class="login-container">
    <div class="absolute-child">
      <div class="login-title">
        <div class="title-desc login-in">登录</div>
        <div class="title-desc" @click="zhuce">注册</div>
      </div>
      <el-form ref="form" autocomplete="off">
        <div class="input-box">
          <i class="icon-lock"></i>
          <el-input ref="usernameInput" v-model="loginInfo.username" placeholder="请输入用户名" clearable
            autocomplete="off"></el-input>
        </div>
        <div class="input-box">
          <i class="icon-pas"></i>
          <el-input ref="passwordInput" v-model="loginInfo.password" type="password" show-password placeholder="请输入密码"
            clearable autocomplete="off"></el-input>
        </div>
      </el-form>
      <!-- <div style="margin:20px auto;text-align:center">
        <el-button class="el-btn" type="primary" round @click="login">登 录</el-button>
      </div>-->
      <i class="denglu" @click="login"></i>
    </div>
  </div>
</template>
<script>
import http from "@http";

// import { getUserInfo } from "@/api/user";
// import { getMenuTree } from "@/api/permissions/menu";
export default {
  data() {
    return {
      loginInfo: {
        client_id: "client",
        client_secret: "123456",
        grant_type: "password",
        username: "",
        password: ""
      }
    };
  },
  mounted() {
    // 手动清空绑定的数据
    this.loginInfo.username = "";
    this.loginInfo.password = "";
    window.addEventListener('keyup', this.handleKeyUp);
  },

  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('keyup', this.handleKeyUp);
  },

  methods: {
    handleKeyUp(event) {
      if (event.key === 'Enter') {
        this.login();
      }
    },
    zhuce() {
      this.msgerror("暂未开放！");
    },
    login() {
      if (!this.loginInfo.username) {
        this.msgerror("请输入账号");
        return;
      }
      if (!this.loginInfo.password) {
        this.msgerror("请输入密码");
        return;
      }
      this.showLoading('登录中...')
      // 将 loginInfo 对象转换为 x-www-form-urlencoded 格式
      const formData = `client_id=client&client_secret=123456&grant_type=password&username=${this.loginInfo.username}&password=${this.loginInfo.password}`;

      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      http
        .post(
          `${process.env.VUE_APP_SERVE}/lskj-auth/oauth2/token`,
          formData,
          config
        )
        .then(res => {
          if (res.access_token) {
            localStorage.setItem(
              "access_token",
              JSON.stringify(res.access_token)
            );
          }
          this.msgsuccess("登录成功");
          this.$router.replace("/homePage");
        })
        .catch(error => {
          console.log(error, 'error');
          console.error("Error:", error);
        })
        .finally(() => {
          this.hideLoading()
        })


    }
  }
};
</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  background-image: url("../../assets/loginbg.jpg");
  background-size: 100% 100%;
  position: relative;
  /* 使得子元素可以使用绝对定位 */
}

.absolute-child {
  position: absolute;
  top: 54%;
  /* 保持相对居中 */
  left: 76%;
  transform: translate(-50%, -50%);
  /* 用来使子元素居中 */

  width: 19%;
  /* 默认占满父容器宽度 */
  max-width: 400px;
  /* 设置最大宽度 */
  max-height: 420px;
  /* 设置最大高度 */
  overflow: hidden;
  /* 防止内容溢出 */
  padding: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  /* 包含 padding 和 border 在内的总宽度和高度 */
  color: white;
  /* 设置字体颜色为白色，以便在背景上能清楚看到 */
  padding-top: 100px;

  .login-title {
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    color: #ccc;
    font-size: 20px;
    font-family: "黑体";

    .title-desc {
      cursor: pointer;
    }

    .login-in {
      font-size: 26px;
      color: #fff;
      border-bottom: 4px solid #fff;
    }
  }

  .label {
    margin-bottom: 10px;
  }
}

/* 添加响应式设计来适配不同的屏幕尺寸 */
@media (max-width: 768px) {
  .absolute-child {
    width: 90%;
    max-width: 500px;
    /* 更小的最大宽度 */
  }
}

@media (max-width: 480px) {
  .absolute-child {
    width: 95%;
    max-width: 400px;
  }
}

.input-box {
  display: flex;
  margin: 45px 0;
  align-items: flex-end;

  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
    margin-right: 6px;
  }
}

.el-btn {
  width: 150px;
  height: 35px;
  font-size: 16px;
  margin: 0 auto;
  font-family: "黑体";
  background: linear-gradient(to bottom,
      #0781e5c9,
      #257493b5);
  /* 上到下的渐变 */
  border: none;
  /* 去掉默认边框 */
  color: #fff;
  /* 设置文字颜色为白色 */
  text-align: center;
  /* 居中文本 */
  display: inline-block;
  /* 使按钮可点击 */
  border-radius: 35px;
  /* 可选：设置圆角 */
  cursor: pointer;
  /* 设置鼠标悬停时的手形 */
  /* 添加阴影 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* 水平偏移量，垂直偏移量，模糊半径，颜色 */
}

::v-deep .el-input__inner {
  background: transparent !important;
  border: 1px solid transparent !important;
  padding: 18px 0 16px 2px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
  font-family: "黑体";
  border-bottom: 1px solid #fff !important;
  background: transparent;
}

// input:-internal-autofill-previewed,
// input:-internal-autofill-selected {
//   -webkit-text-fill-color: red !important;
//   transition: background-color 5000s ease-in-out 0s !important;
// }

.icon-lock {
  width: 30px;
  /* 设置图标的宽度 */
  height: 30px;
  /* 设置图标的高度 */
  background-image: url("../../assets/user.png");
  /* 设置背景图片 */
  background-size: contain;
  /* 让图标适应尺寸 */
  background-repeat: no-repeat;
  /* 防止图片重复 */
  margin-right: 5px;
  position: relative;
  top: 3px;
}

.icon-pas {
  width: 30px;
  /* 设置图标的宽度 */
  height: 30px;
  /* 设置图标的高度 */
  background-image: url("../../assets/pas.png");
  /* 设置背景图片 */
  background-size: contain;
  /* 让图标适应尺寸 */
  background-repeat: no-repeat;
  /* 防止图片重复 */
  margin-right: 5px;
  position: relative;
  top: 3px;
}

.denglu {
  display: block;
  width: 150px;
  height: 50px;
  margin: 20px auto;
  cursor: pointer;
  background-image: url("../../assets/denglu.png");
  /* 设置背景图片 */
  background-size: 100% 90%;
  /* 让图标适应尺寸 */
  background-repeat: no-repeat;
  /* 防止图片重复 */
}
</style>
